import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import ElementSettingsContext from 'src/js/modules/element-settings/helpers/element-settings-context';
import getBatchValues from 'src/js/modules/element-settings/helpers/get-batch-values';

const { Box, IconButton, Popover, PopoverTrigger, PopoverContent } = designSystem;

function SwitchControl({
  id,
  elementIds,
  attributes,
  inverted = false,
  glyph,
  label,
  appearance = 'light-accent',
  onChange,
}) {
  const { state } = useContext(ElementSettingsContext);
  const flattenedValues = getBatchValues(state, { elementIds, attributes }).flat();
  const selected = flattenedValues.every((value) => !!value);

  const handleClick = useCallback(
    () =>
      onChange({
        controlId: id,
        elementIds,
        attributes,
        value: !selected,
      }),
    [id, elementIds, attributes, selected, onChange]
  );

  return (
    <Box>
      <Popover width={192} appearance="dark" description={label}>
        <PopoverTrigger>
          <IconButton
            size="large"
            glyph={glyph}
            selected={inverted ? !selected : selected}
            appearance={appearance}
            onClick={handleClick}
          />
        </PopoverTrigger>
        <PopoverContent />
      </Popover>
    </Box>
  );
}

SwitchControl.propTypes = {
  id: PropTypes.string.isRequired,
  elementIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  attributes: PropTypes.arrayOf(PropTypes.string).isRequired,
  inverted: PropTypes.bool,
  glyph: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  appearance: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default SwitchControl;
